import { useQuery } from "@tanstack/react-query"
import { campaignReachQuery } from "../lib/campaignReachQuery"

export function useCampaignReachQuery(...args: Parameters<typeof campaignReachQuery>) {
  return useQuery(campaignReachQuery(...args))
}
